import { DialogConfirmComponent } from "./../../dialog/dialog-confirm/dialog-confirm.component";
import { TipoCaixaService } from "./../../../service/caixa/tipo-caixa.service";
import { AreaService } from "./../../../service/cliente/area.service";
import { TipoCaixaModel } from "./../../../model/caixa/tipocaixa.model";
import { MatDialog } from "@angular/material/dialog";
import { ExibirConteudoCaixaComponent } from "./../../caixa/exibir-conteudo-caixa/exibir-conteudo-caixa.component";
import { CaixaService } from "./../../../service/caixa/caixa.service";
import {
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AuthenticationService } from "@alfresco/adf-core";
import { ActivatedRoute, Router } from "@angular/router";
import { SolicitacaoModel } from "./../../../model/solicitacao/solicitacao.model";
import { SolicitacaoService } from "./../../../service/solicitacao/solicitacao.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import * as CryptoJS from "crypto-js";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { TipoCaixaComponent } from "../../caixa/tipo-caixa/tipo-caixa.component";
import { IndicarConteudoDialogComponent } from "../indicar-conteudo-dialog/indicar-conteudo-dialog.component";
import { CaixaConteudoDTOModel } from "../../../model/solicitacao/caixaConteudoDTO.model";
@Component({
  selector: "app-listar-solicitacao",
  templateUrl: "./listar-solicitacao.component.html",
  styleUrls: ["./listar-solicitacao.component.scss"],
})
export class ListarSolicitacaoComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("categoryPaginator", { read: MatPaginator })
  paginatorCaixa: MatPaginator;
  @ViewChild(MatSort) sortCaixa: MatSort;
  caixas: any[] = [];
  displayedColumns = [
    "select",
    "rgCaixa",
    "numeroCaixa",
    "areaCodigo",
    "descricaoArea",
    "codAlternativo",
    "descricaoTipoCaixa",
    "descricaoConteudoCaixa",
    "statusCaixa",
    "qtdItens",
    "dataAbertura",
    "acoes",
  ];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceCaixa = new MatTableDataSource<any[]>([]);
  caixasConteudo: any[] = [];
  displayedColumnsCaixa = [
    "select",
    "rgCaixa",
    "descricaoArea",
    "numeroCaixa",
    "codAlternativo",
    "descricaoTipoCaixa",
    "descricaoConteudoCaixa",
    "statusCaixa",
    "qtdItens",
    "dataAbertura",
    "acoes",
  ];
  public solicitacao = {} as SolicitacaoModel;
  public solicitacaoId;
  public deData;
  public loading = true;
  public inputPesquisa = false;
  public submit = false;
  public clienteId;
  public disabled = ["string"];
  public pesquisaForm: FormGroup;
  public pesquisaFormArray: FormArray;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public idCaixas: any[] = [];
  public caixasId: any[] = [];
  public inicial = true;
  public areas: any[] = [];
  public tiposCaixas: TipoCaixaModel[];
  public cliente;
  public listarCaixas = true;
  public listarAddCaixa = false;
  public buttonDelete = true;
  public tpSolicitacao;
  public disabledSolic = false;
  nrSolic = new FormControl("");
  adm = false;
  acervo = false;
  solicitacaoMenu = true;
  caixaSolic = false;
  public searchBySolicId = false;
  nrSolicitacao;
  searchBySolicIdShow = false;
  conteudosCaixa: CaixaConteudoDTOModel[];
  agrupados: any[] = [];
  showDocumentos = false;
  constructor(
    private authService: AuthenticationService,
    private solicitacaoService: SolicitacaoService,
    private caixaService: CaixaService,
    private formBuilder: FormBuilder,
    private areaService: AreaService,
    private tipoCaixaService: TipoCaixaService,
    private dialog: MatDialog,
    private router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(
      (params) => (this.solicitacaoId = params["id"])
    );
    this.deData = CryptoJS.AES.decrypt(
      decodeURIComponent(this.solicitacaoId),
      "pcdoc"
    );
    this.solicitacaoId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.getSolicitacao(this.solicitacaoId);

    this.pesquisaForm = this.formBuilder.group({
      area: [null, Validators.required],
      tipoCaixa: [TipoCaixaModel, Validators.required],
      rgCaixa: ["", Validators.required],
      numeroCaixa: ["", Validators.required],
      codAlternativo: ["", Validators.required],
      dataAbertura: ["", Validators.required],
      qtdItens: [""],
      descricaoConteudoCaixa: ["", Validators.required],
      cliente: [null],
    });

    this.caixasSolicitacao(this.solicitacaoId);
    this.listarConteudoSolicitacao(this.solicitacaoId);
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(
      (data) => {
        console.log(data);
        this.solicitacao = data;
        this.clienteId = data.cliente.id;
        this.cliente = data.cliente;
        this.tpSolicitacao = data.tipoDaSolicitacao;
        console.log(this.tpSolicitacao);
        if (this.tpSolicitacao === "REALOCACAO_INTERNA") {
          this.searchBySolicId = true;
        } else {
          this.searchBySolicId = false;
        }

        if (
          this.tpSolicitacao === "REQUISICAO_CONTEUDO" ||
          this.tpSolicitacao === "DEVOLUCAO_CONTEUDO"
        ) {
          this.showDocumentos = true;
        }
        this.loading = false;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarAreasCliente() {
    this.areaService.getAreasUsuarioCliente(this.clienteId).subscribe(
      (data) => {
        this.areas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarTiposDeCaixas() {
    this.tipoCaixaService.getTipoCaixasUsuario().subscribe(
      (data) => {
        this.tiposCaixas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarConteudoSolicitacao(solicitacaoId: number) {
    this.solicitacaoService.buscarConteudoSolicitacao(solicitacaoId).subscribe(
      (data) => {
        console.log(data);
        if (data.success) {
          this.conteudosCaixa = data.result;
          this.formatarRetorno(this.conteudosCaixa);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  formatarRetorno(dados: any[]) {
    const agrupados: { [key: string]: any } = {};
    dados.forEach((item) => {
      const rgCaixa = item.rgCaixa;
      if (!agrupados[rgCaixa]) {
        agrupados[rgCaixa] = {
          rgCaixa: rgCaixa,
          conteudos: [],
        };
      }
      const conteudo = {
        descConteudo: item.descConteudo,
        codConteudo: item.codConteudo,
        tipoConteudo: item.tipoConteudo,
      };
      agrupados[rgCaixa].conteudos.push(conteudo);
    });

    const resultado = Object.keys(agrupados).map((key) => agrupados[key]);
    // const resultadoJSON = JSON.stringify(resultado);
    console.log(resultado);
    this.agrupados = resultado;
    this.disabledSolic = false;
  }

  addItem() {
    this.disabled.push("string");
    this.pesquisaFormArray = this.pesquisaForm.get(
      "pesquisaFormArray"
    ) as FormArray;
    this.pesquisaFormArray.push(this.createItem());
    this.inicial = false;
  }

  remover(indice: any) {
    if (indice > 0) {
      this.pesquisaFormArray.removeAt(indice);
      this.disabled.splice(indice, 1);
    } else {
      this.openSnackBarError(
        "Erro ao remover. O primeiro filtro é obrigatório !"
      );
    }
  }

  checkAll(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSource.data[i]["isSelected"] = true;
        this.idCaixas.push(this.dataSource.data[i]["id"]);
      }
    } else {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSource.data[i]["isSelected"] = false;
        var id = this.dataSource.data[i]["id"];
        let index = this.idCaixas.indexOf(id);
        this.idCaixas.splice(index, 1);
      }
    }
  }

  checkIndividual(checked, idCaixa) {
    if (checked === true) {
      this.idCaixas.push(idCaixa);
    } else {
      let index = this.idCaixas.indexOf(idCaixa);
      this.idCaixas.splice(index, 1);
    }
  }

  checkAllCaixa(e) {
    var pageIndex = this.paginator.pageIndex;
    var pageSize = this.paginator.pageSize;
    var lengthData = this.paginator.length;
    if (e === true) {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSourceCaixa.data[i]["isSelectedCaixa"] = true;
        this.caixasId.push(this.dataSourceCaixa.data[i]["id"]);
        this.buttonDelete = false;
      }
    } else {
      for (
        let i = pageIndex * pageSize;
        i < pageIndex * pageSize + pageSize && i < lengthData;
        i++
      ) {
        this.dataSourceCaixa.data[i]["isSelectedCaixa"] = false;
        var id = this.dataSourceCaixa.data[i]["id"];
        let index = this.caixasId.indexOf(id);
        this.caixasId.splice(index, 1);
        this.buttonDelete = true;
      }
    }
  }

  checkIndividualCaixa(checked, idCaixa) {
    if (checked === true) {
      this.caixasId.push(idCaixa);
    } else {
      let index = this.caixasId.indexOf(idCaixa);
      this.caixasId.splice(index, 1);
    }
    if (this.caixasId.length > 0) {
      this.buttonDelete = false;
    } else {
      this.buttonDelete = true;
    }
  }

  inserirItens() {
    const dialogRef = this.dialog.open(IndicarConteudoDialogComponent, {
      data: {
        caixas: this.caixasConteudo,
        areaId: this.solicitacao.area.id,
        clienteId: this.solicitacao.cliente.id,
        solicitacaoId: this.solicitacaoId,
        tpSolicitacao: this.solicitacao.tipoDaSolicitacao,
      },
      width: "100%",
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
      this.listarConteudoSolicitacao(this.solicitacaoId);
    });
  }

  add() {
    console.log(this.idCaixas);
    if (this.idCaixas.length > 0) {
      this.solicitacaoService
        .addCaixasSolicitacao(this.idCaixas, this.solicitacaoId)
        .subscribe(
          (data) => {
            console.log(data);
            this.openSnackBarSuccess("Caixas adicionadas com sucesso !");
            // this.pesquisar();
            setTimeout(() => {
              this.listarAddCaixa = false;
              this.listarCaixas = true;
              this.caixasSolicitacao(this.solicitacaoId);
            }, 2500);
          },
          (err) => {
            console.error(err);
            if (
              err.error.message ===
              "Não é possível adicionar a mesma caixa em uma mesma solicitação"
            ) {
              this.openSnackBarError(err.error.message);
            }
          }
        );
    } else {
      this.openSnackBarError("Nenhuma caixa selecionada !");
    }
  }

  rmData() {
    this.dataSource = new MatTableDataSource();
  }

  caixasSolicitacao(solicitacaoId: Number) {
    this.solicitacaoService.listarCaixasSolicitacao(solicitacaoId).subscribe(
      (data) => {
        console.log(data);
        console.log(this.agrupados);
        if (data.length > 0) {
          if (this.agrupados.length > 0) {
            this.disabledSolic = false;
          } else {
            if (
              this.solicitacao.tipoDaSolicitacao != "REQUISICAO_CONTEUDO" &&
              this.solicitacao.tipoDaSolicitacao != "DEVOLUCAO_CONTEUDO"
            ) {
              this.disabledSolic = false;
            } else {
              this.disabledSolic = true;
            }
          }
        } else {
          if (
            this.solicitacao.tipoDaSolicitacao != "REQUISICAO_CONTEUDO" &&
            this.solicitacao.tipoDaSolicitacao != "DEVOLUCAO_CONTEUDO"
          ) {
            this.disabledSolic = false;
          } else {
            this.disabledSolic = true;
          }
        }
        data = data.map((value) => {
          value.isSelectedCaixa = false;
          return value;
        });
        this.dataSourceCaixa = new MatTableDataSource(data);
        this.dataSourceCaixa.paginator = this.paginatorCaixa;
        this.dataSourceCaixa.sort = this.sortCaixa;
        this.caixasConteudo = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  caixasSolicitacaoAdd(solicitacaoId: Number) {
    this.solicitacaoService
      .listarCaixasSolicitacaoRealocacao(solicitacaoId)
      .subscribe(
        (data) => {
          console.log(data);
          this.dataSource.data = data;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.nrSolic.setValue("");
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          if (err.error.message === "No message available") {
            this.openSnackBarError(
              `Erro ao buscar as caixas da solicitação: ${solicitacaoId} ! Verifique a existência desta solicitação.`
            );
          } else {
            this.openSnackBarError(err.error.message);
          }
          this.nrSolic.setValue("");
          this.searchBySolicIdShow = false;
          console.error(err);
        }
      );
  }

  addCaixas() {
    this.listarCaixas = false;
    this.listarAddCaixa = true;
    this.idCaixas = [];
  }

  listCaixas() {
    this.listarAddCaixa = false;
    this.listarCaixas = true;
    this.caixasSolicitacao(this.solicitacaoId);
  }

  removerCaixaSolicitacao() {
    let rgAtual = null;
    this.agrupados.forEach((a) => {
      this.dataSourceCaixa.data.forEach((caixa) => {
        let cx: any = caixa;
        if (a.rgCaixa === cx.rgCaixa) {
          rgAtual = cx.rgCaixa;
        }
      });
    });

    if (rgAtual != null) {
      this.openSnackBarError(
        "Existem caixas que não podem ser removidas, pois possuem conteúdo(s) incluídos!"
      );
    } else {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: {
          name: "Deseja remover a(s) caixa(s) selecionada(s) ?",
          from: "listar-solicitacao.component.ts",
        },
      });
      // const snack = this.snackBar.open('Snack bar open before dialog');

      dialogRef.afterClosed().subscribe((confirmed: any) => {
        console.log(confirmed.apagar);
        if (confirmed.apagar === true) {
          this.removerCaixas();
        }
      });
    }
  }

  removerCaixas() {
    this.solicitacaoService
      .removeCaixasSolicitacao(this.caixasId, this.solicitacaoId)
      .subscribe(
        () => {
          console.log("Ok");
          this.openSnackBarSuccess("Caixa(s) removida(s) com sucesso !");
          this.caixasSolicitacao(this.solicitacaoId);
          this.buttonDelete = true;
        },
        (err) => {
          console.error(err);
          this.openSnackBarError("Erro !");
        }
      );
  }

  exibirConteudos(caixaId: number) {
    const dialogRef = this.dialog.open(ExibirConteudoCaixaComponent, {
      width: "100%",
      data: { caixaId: caixaId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      atributo: ["", [Validators.required]],
      operador: ["", Validators.required],
      conteudo: ["", [Validators.required]],
    });
  }

  onSubmit() {
    this.submit = true;
  }

  onChange(e, indice) {
    this.desabilitarOperador(indice);
  }

  desabilitarOperador(indice) {
    const group = this.pesquisaForm.get("pesquisaFormArray").value[indice];
    const arrayGroup = ["codArea", "qtdItens"];
    if (arrayGroup.includes(group.atributo)) {
      this.disabled[indice] = "number";
    } else if (group.atributo === "status") {
      this.disabled[indice] = "enum";
    } else if (group.atributo === "dataAbertura") {
      this.disabled[indice] = "date";
    } else {
      this.disabled[indice] = "string";
    }
  }

  pesquisar() {
    if (this.nrSolic.value !== "" && this.nrSolic.value !== null) {
      this.caixaSolic = true;
      this.loading = true;
      this.nrSolicitacao = this.nrSolic.value;
      this.searchBySolicIdShow = true;
      this.caixasSolicitacaoAdd(this.nrSolic.value);
    } else {
      this.searchBySolicIdShow = false;
      this.caixaSolic = false;
      this.loading = true;
      this.pesquisaForm.get("cliente").setValue(this.cliente);
      this.caixaService
        .pesquisaImplantacao(
          this.pesquisaForm.value,
          this.clienteId,
          this.tpSolicitacao
        )
        .subscribe(
          (data) => {
            if (data.length === 0) {
              this.loading = false;
              this.openSnackBarError("Nenhum resultado encontrado !");
              return;
            }
            data = data.map((value) => {
              value.isSelected = false;
              return value;
            });
            this.loading = false;
            console.log(this.dataSource.data.length);
            const dados = data;
            if (this.dataSource.data.length === 0) {
              this.dataSource.data = data;
            } else {
              console.log(this.dataSource.data);
              const dadosAtuais = this.dataSource.data;
              let flag = false;
              if (data.length === 1) {
                dadosAtuais.forEach((el) => {
                  const caixa: any = el;
                  if (caixa.rgCaixa === data[0].rgCaixa) {
                    flag = true;
                  }
                });
                if (!flag) {
                  dadosAtuais.push(data[0]);
                } else {
                  this.openSnackBarError(
                    "Esta caixa já está foi inserida na busca !"
                  );
                }
                console.log(dadosAtuais);
                this.dataSource.data = dadosAtuais;
              } else {
                this.dataSource = new MatTableDataSource(data);
              }
            }
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.pesquisaForm.reset();
          },
          (err) => {
            this.pesquisaForm.reset();
            console.error(err);
            this.loading = false;
            this.openSnackBarError("Erro ao tentar realizar a busca.");
          }
        );
    }
  }

  limpar() {
    this.submit = false;
  }

  goToProcess(solicId) {
    this.router.navigate(["/processar-solicitacao", solicId]);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/listar-solicitacao/listar-solicitacao.component.ts